import ReportDataTable from "./ReportDataTable";

const formatDateTime = (value) => {
  if (!value) return "--------";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString();
};

const quantityWithUnit = (quantity, unit) => {
  if (!(quantity || quantity === 0)) return "--------";

  return `${quantity} ${unit}`.trim();
};

const InventoryPurchaseLog = ({ rows = [], loading }) => {
  const columns = [
    { key: "serial", label: "S/N", render: (row) => row.serial },
    {
      key: "update_time",
      label: "Update Time",
      render: (row) => formatDateTime(row.update_time),
    },
    { key: "ingredient_name", label: "Ingredient" },
    { key: "vendor_name", label: "Vendor" },
    { key: "updated_by", label: "Updated By" },
    {
      key: "new_quantity",
      label: "Quantity",
      render: (row) => quantityWithUnit(row.new_quantity, row.unit),
    },
    { key: "purchase_amount", label: "Purchase Amount(Rs.)" },
  ];

  const reportRows = rows.map((row, index) => ({
    ...row,
    serial: index + 1,
  }));

  return (
    <ReportDataTable
      className="inventory-purchase-log"
      columns={columns}
      rows={reportRows}
      loading={loading}
      emptyMessage="No inventory purchase log data found."
    />
  );
};

export default InventoryPurchaseLog;
